export default "__VITE_ASSET__Xft0WSlN__"